var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showDefault)?_c('img',{staticClass:"image",attrs:{"src":_vm.src,"alt":"Kommune logo"},on:{"error":function($event){_vm.showDefault = true}}}):_vm._e(),(_vm.showDefault)?_c('MunicipalityLogo',{staticClass:"logo"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }